module.exports = __webpack_public_path__ + "img/PD1505106436865261568.298220a6.png";